const api = {
	listStoresByMall: '/store/listStoresByMall',
	listOrdersByMall: '/order/listOrdersByMall',
	exportMallOrderListByMall: '/order/exportMallOrderListByMall',   // 导出订单
	orderDetail: '/order/getOrderByMall', // 订单详情
	getEnabledPointSystemInfo: '/integralMall/getEnabledPointSystemInfo', // 获取经商城系统信息
	listPaymentType: '/order/listPaymentType', //获取支付方式
};

const routes = {
	'/mall-order': '交易记录',
	'/mall-order/detail': '交易详情',
};

export {
	api,
	routes,
};
